<template>
  <div>
    <b-row v-if="samples.models.length">
      <b-col
        cols="6"
        v-for="(sample, sampleIndex) in samples.models"
        :key="sampleIndex"
      >
        <sample-receiving-label
          :customer="customer"
          :sample="sample"
          :submission="submission"
          :receive="receive"
          @receiveSample="emit_sample => $emit('receiveSample', emit_sample)"
        />
      </b-col>
    </b-row>
    <b-alert v-else show>Currently samples provided.</b-alert>
  </div>
</template>

<script>
import SampleCollection from "@/collections/lab/SampleCollection";
import CustomerModel from "@/models/crm/CustomerModel";
import SampleReceivingLabel from "./SampleReceivingLabel";

export default {
  name: "SampleReceivingLabels",
  components: { SampleReceivingLabel },
  props: {
    customer: {
      type: CustomerModel,
      default: () => null
    },
    samples: {
      type: SampleCollection,
      default: () => new SampleCollection()
    },
    submission: {
      type: Object,
      default: () => null
    },
    receive: {
      type: Boolean,
      default: false
    }
  }
};
</script>
